module.exports = __webpack_public_path__ + "static/w-zahralita-02facb0b5c8b4ee6155a72f48b57357e.jpg";